import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { fetchAllCPTCodes, insertOrUpdateCodeGroup } from '../../../store/adminCPTCodesSlice.slice';
import { RootState } from '../../../reducers';
import { copyObject } from '../../../utils/common';
import CPTCodes from '../CPTCode/CPTCodes';

const EditRoleCodesModal = (props: any) => {
    const dispatch = useAppDispatch();
    const { activeCptCodes, selectedGroup, selectedIds, selectedRole } = useSelector((state: RootState) => state.adminCPTCodesSlice);

    // useEffect(() => {
    //     dispatch(fetchAllCPTCodes());
    // }, [dispatch]);

    const handleSubmit = () => {
        const selectedCPTCodes = activeCptCodes.filter((cptCode) => selectedIds.includes(cptCode.Id));
        const selectedGroupCopy = copyObject(selectedGroup);
        const role = selectedGroupCopy.CPTRoleCodes.find((role) => role.Role === selectedRole);
        role.Codes = [...selectedCPTCodes];
        dispatch(insertOrUpdateCodeGroup(selectedGroupCopy));
        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="lg">
            <DialogTitle>Add/Remove CPT Codes</DialogTitle>
            <DialogContent>
                <CPTCodes canEdit={false} />
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button variant="outlined" sx={{ minWidth: '120px' }} onClick={props.onClose}>
                    Cancel
                </Button>
                <Button variant="contained" sx={{ minWidth: '120px' }} onClick={handleSubmit}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditRoleCodesModal;
